import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

export const FEATURES_VALUE_QUERY = gql`
	query GetFeaturesValues($businessId: String!, $features: [FeatureInput]) {
		GetFeaturesValues(businessId: $businessId, features: $features) {
			name
			value
		}
	}
`;

export const FEATURES_TEST_BUSINESSES = gql`
	query GetTestBusinesses {
  		GetTestBusinesses
	}
`;

export enum FeaturesEnum {
	//check the usage and remove it
	CAN_BYPASS_ORDER_TYPE_SCREEN = "CAN_BYPASS_ORDER_TYPE_SCREEN",
	TOGGLE_OTP = "TOGGLE_OTP",
	ORDER_TYPE = "ORDER_TYPE",
}
@Injectable({
	providedIn: "root",
})
export class FeatureFlagService {
	features = [
		{
			name: FeaturesEnum.CAN_BYPASS_ORDER_TYPE_SCREEN,
			value: false,
		},
		{
			name: FeaturesEnum.TOGGLE_OTP,
			value: false,
		},
		{
			name: FeaturesEnum.ORDER_TYPE,
			value: false,
		},
	];

	constructor(private apollo: Apollo) {}

	getFeaturesValues(businessId: String) {
		return this.apollo
			.watchQuery({
				query: FEATURES_VALUE_QUERY,
				variables: {
					businessId: businessId,
					features: this.features,
				},
			})
			.valueChanges.subscribe((response: any) => {
				if (response.data.GetFeaturesValues)
					this.features = response.data.GetFeaturesValues;
			});
	}

	getByPassOrderType(businessId: String) {
		return this.apollo
			.watchQuery({
				query: FEATURES_VALUE_QUERY,
				variables: {
					businessId: businessId,
					features: this.features,
				},
			});
	}

	getTestBusinesses(){
		return this.apollo.watchQuery({
			query: FEATURES_TEST_BUSINESSES
		}).valueChanges;
	}
}
